package com.royceecoleman.bill.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import kotlinx.browser.document
import kotlin.random.Random
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@JsModule("markdown-it")
@JsNonModule
private external class MarkdownIt(options: dynamic = definedExternally) {
    fun disable(rules: Array<String>): MarkdownIt

    fun render(markdown: String): String
}

private val aiChatMarkdownRenderer by lazy {
    MarkdownIt(
        js(
            """({
                html: false,
                breaks: true,
                linkify: true
            })""",
        ),
    ).disable(arrayOf("image"))
}

internal fun renderAiChatMarkdownToHtml(markdown: String): String {
    if (markdown.isBlank()) {
        return ""
    }

    return aiChatMarkdownRenderer.render(markdown).trim()
}

@Composable
internal fun AiChatMarkdownContent(markdown: String) {
    val renderedHtml = remember(markdown) { renderAiChatMarkdownToHtml(markdown) }
    val containerId = remember { "ai-chat-markdown-${Random.nextLong()}" }

    Div(
        attrs = {
            id(containerId)
            style {
                property("margin", "0.45rem 0 0")
                property("line-height", "1.6")
                property("color", "#334155")
                property("overflow-wrap", "anywhere")
            }
        },
    )

    DisposableEffect(containerId, renderedHtml) {
        val container = document.getElementById(containerId) as? HTMLElement
        container?.innerHTML = renderedHtml

        onDispose {
            container?.innerHTML = ""
        }
    }
}
